import "./GalleryFiltersMenu.style.css";

import { AuthorizationStatus } from "../../../utils/enums/AuthorizationStatus";
import { SortingType } from "../../../utils/enums/SortingType";
import { useAppSelector } from "../../../store/store";
import { Ref } from "react";
import { Switcher } from "../../../components/base/Switcher/Switcher";
import {
  Button,
  ButtonColor,
  ButtonSize,
} from "../../../components/base/Button/Button";
import { CrossIcon24 } from "../../../components/icons/CrossIcon24";
import { useIsMobile } from "../../../utils/functions/useIsMobile";

interface GalleryFiltersMenuProps {
  className?: string;
  ref?: Ref<HTMLDivElement>;
  tags: [string, number][];
  sortingType: SortingType;
  selectedTags: string[];
  filterOwn: boolean;
  filterFavorites: boolean;
  handleChangeSortingType: (newSortingType: SortingType) => void;
  handleToggleOwnFilter: () => void;
  handleToggleFavoritesFilter: () => void;
  handleToggleTagFilter: (tagName: string) => void;
  handleClickCloseButton: () => void;
}

export const GalleryFiltersMenu = ({
  className,
  ref,
  tags,
  sortingType,
  selectedTags,
  filterOwn,
  filterFavorites,
  handleChangeSortingType,
  handleToggleOwnFilter,
  handleToggleFavoritesFilter,
  handleToggleTagFilter,
  handleClickCloseButton,
}: GalleryFiltersMenuProps) => {
  const authorizationStatus = useAppSelector(
    (state) => state.user.authorizationStatus,
  );
  const isMobile = useIsMobile();

  const sortedTags = tags.sort((a, b) => a[0].localeCompare(b[0]));

  const getStartingSwitcherItem = () => {
    switch (sortingType) {
      case SortingType.Popular:
        return 0;
      case SortingType.PublicationDate:
        return 1;
      case SortingType.Relevance:
        return 2;
      default:
        return 0;
    }
  };

  return (
    <div className={`gallery-filters-menu ${className}`} ref={ref}>
      <header className="gallery-filters-menu__header">
        Настройка фильтров
        <Button
          className="gallery-filters-menu__close-button"
          color={ButtonColor.Empty}
          icon={<CrossIcon24 />}
          onClick={handleClickCloseButton}
        />
      </header>
      <main className="gallery-filters-menu__content">
        <div className="gallery-filters-menu__main">
          <div className="gallery-filters-menu__sorting">
            <div className="gallery-filters-menu__sorting-title">
              Сортировать по...
            </div>
            <Switcher
              className="gallery-filters-menu__sorting-switcher"
              color={ButtonColor.Accent}
              size={ButtonSize.Small}
              items={[
                {
                  content: isMobile ? "лайкам" : "популярности",
                  onActive: () => handleChangeSortingType(SortingType.Popular),
                },
                {
                  content: isMobile ? "дате" : "дате публикации",
                  onActive: () =>
                    handleChangeSortingType(SortingType.PublicationDate),
                },
                {
                  content: isMobile ? "релевантности" : "релевантности",
                  onActive: () =>
                    handleChangeSortingType(SortingType.Relevance),
                },
              ]}
              startingItem={getStartingSwitcherItem()}
              vertical={!isMobile}
            />
          </div>
          {authorizationStatus === AuthorizationStatus.Auth && (
            <div className="gallery-filters-menu__general-filters">
              <div
                className="gallery-filters-menu__filter"
                onClick={handleToggleOwnFilter}
              >
                <span
                  className={`gallery-filters-menu__filter__checkbox ${filterOwn ? "gallery-filters-menu__filter__checkbox_active" : ""}`}
                />
                Мои игры
              </div>
              <div
                className="gallery-filters-menu__filter"
                onClick={handleToggleFavoritesFilter}
              >
                <span
                  className={`gallery-filters-menu__filter__checkbox ${filterFavorites ? "gallery-filters-menu__filter__checkbox_active" : ""}`}
                />
                Избранное
              </div>
            </div>
          )}
        </div>
        <ul className="gallery-filters-menu__tag-filters">
          {sortedTags.map((tag) => (
            <li
              key={tag[0]}
              className="gallery-filters-menu__filter"
              onClick={() => handleToggleTagFilter(tag[0])}
            >
              <span
                className={`gallery-filters-menu__filter__checkbox ${selectedTags.includes(tag[0]) ? "gallery-filters-menu__filter__checkbox_active" : ""}`}
              />
              <div className="gallery-filters-menu__filter__description">
                <span>{tag[0]}</span>
                <span>{tag[1]}</span>
              </div>
            </li>
          ))}
        </ul>
      </main>
    </div>
  );
};
